import 'css-chunksrc/client/scenes/workloads/header/styles.scss';export default {
  "header": "_header_16fj7_1",
  "firstLine": "_firstLine_16fj7_13",
  "secondLine": "_secondLine_16fj7_23",
  "selectors": "_selectors_16fj7_33",
  "filters": "_filters_16fj7_43",
  "creationMenu": "_creationMenu_16fj7_50"
};